var getWebAppBaseUrl = function getWebAppBaseUrl(url) {
  return process.env.NODE_ENV === 'production' ? url.production : url.develop;
};

export default getWebAppBaseUrl;